"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var HistoryProvider_1 = require("../HistoryProvider");

var History =
/** @class */
function (_super) {
  __extends(History, _super);

  function History(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      events: []
    };

    _this.onHistoryEventCallback = function (event) {
      var account = _this.props.account;

      if (event.to === account || event.from === account) {
        _this.setState({
          events: [event].concat(_this.state.events)
        });
      }
    };

    return _this;
  }

  History.prototype.componentDidMount = function () {
    var _a = this.props,
        account = _a.account,
        historyFns = _a.historyFns;
    this.setState({
      events: historyFns.getHistoryEvents({
        account: account
      }).slice()
    });
    historyFns.onHistoryEvent(this.onHistoryEventCallback);
  };

  History.prototype.componentWillUnmount = function () {
    this.props.historyFns.removeHistoryEventListener(this.onHistoryEventCallback);
  };

  History.prototype.render = function () {
    return react_1.default.createElement(react_1.Fragment, null, this.props.render(this.state.events));
  };

  return History;
}(react_1.Component);

exports.default = HistoryProvider_1.withHistory(History);